import { Box, Typography, Paper } from '@mui/material';
import { WizardFormData } from '../schemas';
import DetailRow from './DetailRow';
import { appendUidToUrl, buildEntryLink, buildRLink } from '../utils/domains';

interface OfferDetailsSectionProps {
  formData: WizardFormData;
  domains: any[];
  getDomainName: (domainId: string, domains: any[]) => string;
}

function OfferDetailsSection({ formData, domains, getDomainName }: OfferDetailsSectionProps) {
  const getRLink = (): string => {
    const domain = domains.find((item) => item._id === formData.redirectDomainId);

    if (!domain) return 'N/A';

    const isOnlydrops = domain.domainName.startsWith('onlydrops');

    if (isOnlydrops) {
      return appendUidToUrl(domain.domainLink, formData.offerUniqueId);
    }

    return buildRLink(domain.domainLink, formData.offerUniqueId);
  };

  const getEntryLink = () => {
    const domain = domains.find((item) => item._id === formData.entryDomainId);
    if (!domain) return 'N/A';
    return buildEntryLink(domain.domainLink, formData.offerUniqueId);
  };

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom color="primary">
        Offer Details
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <DetailRow label="Name" value={formData.offerName} />
        <DetailRow label="Link" value={formData.offerLink} valueStyle={{ wordBreak: 'break-all' }} />
        <DetailRow label="Entry Domain" value={getDomainName(formData.entryDomainId, domains)} />
        <DetailRow label="Entry Link" value={getEntryLink()} valueStyle={{ wordBreak: 'break-all' }} />
        <DetailRow label="Redirect Domain" value={getDomainName(formData.redirectDomainId, domains)} />
        <DetailRow label="Redirect Link" value={getRLink()} valueStyle={{ wordBreak: 'break-all' }} />
      </Box>
    </Paper>
  );
}

export default OfferDetailsSection;
